import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomer } from "../../context/CustomerContext";
import { useWishlist } from "../../context/WishlistContext";
import WishlistProductGrid from "../../components/WishlistProductGrid";
import cardStyles from "../Products.module.css";
import sectionStyles from "./WishlistSection.module.css";

const WishlistSection = () => {
  const { customer, loading } = useCustomer();
  const { isWishlistLoading } = useWishlist();

  if (loading) {
    return (
      <div className={sectionStyles.emptyWishlist}>Завантаження...</div>
    );
  }

  if (!customer) {
    return <Navigate to="/" replace />;
  }

  return (
    <WishlistProductGrid
      cardStyles={cardStyles}
      sectionClassName={sectionStyles.wishlistSection}
      emptyClassName={sectionStyles.emptyWishlist}
      isLoading={isWishlistLoading}
    />
  );
};

export default WishlistSection;
